import React from 'react';
import { Calendar, Book, Download, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#9a6ebd] font-medium">🌟 Nos Services</span>
          <h2 className="text-3xl font-bold text-[#323c5f] mt-2">
            Des solutions adaptées pour votre réussite
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Choisissez la méthode qui vous convient le mieux !
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {/* Cours Particuliers */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#ceace8] hover:scale-105 transition-transform duration-300 flex flex-col">
            <div className="w-12 h-12 bg-[#9a6ebd] rounded-xl flex items-center justify-center mb-6">
              <Calendar className="text-white" size={24} />
            </div>
            <h3 className="text-xl font-bold text-[#323c5f] mb-3">
              👩‍🏫 Cours Particuliers
            </h3>
            <p className="text-gray-600 mb-6 flex-grow">
              Des cours en visio personnalisés pour progresser à votre rythme. 
              On s'adapte à vos besoins !
            </p>
            <Link
              to="/cours-particuliers"
              className="block w-full bg-[#9a6ebd] text-white px-6 py-3 rounded-xl hover:bg-[#8a5dad] transition-colors text-center"
            >
              Je réserve →
            </Link>
          </div>

          {/* Flashcards */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#ceace8] hover:scale-105 transition-transform duration-300 flex flex-col">
            <div className="w-12 h-12 bg-[#9a6ebd] rounded-xl flex items-center justify-center mb-6">
              <Book className="text-white" size={24} />
            </div>
            <h3 className="text-xl font-bold text-[#323c5f] mb-3">
              🎯 Flashcards SES
            </h3>
            <p className="text-gray-600 mb-6 flex-grow">
              Des flashcards ludiques pour mémoriser facilement les notions essentielles. 
              Apprenez où vous voulez !
            </p>
            <Link
              to="/flashcards"
              className="block w-full bg-[#9a6ebd] text-white px-6 py-3 rounded-xl hover:bg-[#8a5dad] transition-colors text-center"
            >
              Je découvre →
            </Link>
          </div>

          {/* Sujets Bac */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#ceace8] hover:scale-105 transition-transform duration-300 flex flex-col">
            <div className="w-12 h-12 bg-[#9a6ebd] rounded-xl flex items-center justify-center mb-6">
              <FileText className="text-white" size={24} />
            </div>
            <h3 className="text-xl font-bold text-[#323c5f] mb-3">
              📝 Sujets Bac
            </h3>
            <p className="text-gray-600 mb-6 flex-grow">
              Tous les sujets de bac SES avec leurs corrigés vidéo détaillés. 
              Entraînez-vous efficacement !
            </p>
            <Link
              to="/sujets-bac"
              className="block w-full bg-[#9a6ebd] text-white px-6 py-3 rounded-xl hover:bg-[#8a5dad] transition-colors text-center"
            >
              Je m'entraîne →
            </Link>
          </div>

          {/* Ressources Gratuites */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#ceace8] hover:scale-105 transition-transform duration-300 flex flex-col">
            <div className="w-12 h-12 bg-[#9a6ebd] rounded-xl flex items-center justify-center mb-6">
              <Download className="text-white" size={24} />
            </div>
            <h3 className="text-xl font-bold text-[#323c5f] mb-3">
              📚 Ressources Gratuites
            </h3>
            <p className="text-gray-600 mb-6 flex-grow">
              Accédez à notre bibliothèque de fiches et d'exercices corrigés. 
              C'est 100% gratuit !
            </p>
            <Link
              to="/ressources"
              className="block w-full bg-[#9a6ebd] text-white px-6 py-3 rounded-xl hover:bg-[#8a5dad] transition-colors text-center"
            >
              Je télécharge →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;